import { Attribution, AttributionLink } from '@99designs/emu';
import { FormattedReactMessage, formatMessage } from '@99designs/frontend-components/i18n';

interface DesignerAttributionProps {
    displayName: string;
    link?: string;
}

export function ContestDesignerAttribution({ displayName, link }: DesignerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('Winning design by <DesignerLink>{displayName}</DesignerLink>')}
                    values={{ displayName }}
                    replacements={{
                        DesignerLink: (
                            <AttributionLink
                                href={link}
                                aria-label={formatMessage(__('Profile for {displayName}'), {
                                    displayName,
                                })}
                            />
                        ),
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('Winning design by {displayName}'), {
                displayName,
            })}
        </Attribution>
    );
}

export function DesignerAttribution({ displayName, link }: DesignerAttributionProps) {
    if (link) {
        return (
            <Attribution>
                <FormattedReactMessage
                    message={__('by <DesignerLink>{displayName}</DesignerLink>')}
                    values={{ displayName }}
                    replacements={{
                        DesignerLink: (
                            <AttributionLink
                                href={link}
                                aria-label={formatMessage(__('Profile for {displayName}'), {
                                    displayName,
                                })}
                            />
                        ),
                    }}
                />
            </Attribution>
        );
    }

    return (
        <Attribution>
            {formatMessage(__('by {displayName}'), {
                displayName,
            })}
        </Attribution>
    );
}
